export default {
  seoTitle: 'Купить {{- title}} в Лепеле',
  seoDescription:
    'Купить {{- title}} по низким ценам в Лепеле с доставкой по Беларуси. Технические характеристики, фото и стоимость. ✔ Официальная гарантия. ✔ Рассрочка',
};
